module.exports = __webpack_public_path__ + "img/odnoklassniki-icon.dd66363c.svg";